import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import { InteractionStatus } from "@azure/msal-browser";

export default function IdentityManager() {
    const { instance, inProgress, accounts } = useMsal();
    const [apiData] = useState(null);

    useEffect(() => {
        if (inProgress !== InteractionStatus.None || accounts.length === 0) {
            return '';
        }
        var userName = accounts[0].username ?? accounts[0].idTokenClaims.emails[0];
        localStorage.setItem("_urn", Buffer.from(userName).toString('base64'));
        localStorage.setItem("_fullName", accounts[0].name);
        localStorage.setItem("_userName", userName);
    }, [instance, accounts, inProgress, apiData]);

    return ''; 
}